import React, { useState } from "react";
import {
  ActiveCheckbox,
  EditButton,
  DeleteButton,
} from "../../common/TableCols";
import { PlusCircleOutlined } from "@ant-design/icons";
import { Table, Card, Button, Spin, Row, Col } from "antd";
import PropTypes from "prop-types";
import { RecordType } from "../../model/common/RecordType";
import FilterGridDropdown from "../../common/FilterGridDropdown";
import EntryFormFooter from "../../common/EntryFormFooter";
import { useTranslation } from "react-i18next";

export const HolidayProfileForm = ({
  holidayProfile,
  onDelete,
  onAdd,
  onEdit,
  isLoading,
  onRowSelected,
  rowSelected,
  setCurrentPage,
  currentPage,
}) => {
  const { t } = useTranslation();

  const HolidayProfileActiveCheckbox = (value) => (
    <ActiveCheckbox isChecked={value} />
  );

  const [searchText, setSearchText] = useState("");

  const HolidayProfileActionButtons = (value, record) => (
    <Row>
      <Col span={12}>
        <EditButton fncEdit={() => onEdit(value)} />
      </Col>
      <Col
        span={12}
        style={{
          display: record.RcdType === RecordType.USER ? "" : "none",
        }}
      >
        <DeleteButton fncDelete={() => onDelete(value)} />
      </Col>
    </Row>
  );

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const columns = [
    {
      title: t("holidayProfileForm.holiday_profile_code"),
      dataIndex: "ProfileCode",
      key: "ProfileCode",
      width: 200,
      sorter: (a, b) => a.ProfileCode.localeCompare(b.ProfileCode),
      sortDirections: ["ascend", "descend"],
      ...FilterGridDropdown(
        "ProfileCode",
        searchText,
        handleSearch,
        handleReset,
        "Holiday Profile Code",
        t
      ),
    },
    {
      title: t("general.description"),
      dataIndex: "ProfileDesc",
      key: "ProfileDesc",
      sorter: (a, b) => a.ProfileDesc.localeCompare(b.ProfileDesc),
      sortDirections: ["ascend", "descend"],
      ...FilterGridDropdown(
        "ProfileDesc",
        searchText,
        handleSearch,
        handleReset,
        "Description",
        t
      ),
    },
    {
      title: t("general.year"),
      dataIndex: "Yr",
      key: "Yr",
      align: "right",
      sorter: (a, b) => a.Yr - b.Yr,
      sortDirections: ["ascend", "descend"],
      width: 100,
      ...FilterGridDropdown(
        "Yr",
        searchText,
        handleSearch,
        handleReset,
        "Year",
        t
      ),
    },
    {
      title: t("general.active"),
      dataIndex: "Active",
      key: "Active",
      align: "center",
      width: 100,
      render: HolidayProfileActiveCheckbox,
    },
    {
      title: t("general.action"),
      dataIndex: "ProfileKey",
      key: "HolidayProfileActions",
      align: "center",
      width: 100,
      render: HolidayProfileActionButtons,
    },
  ];

  const tablePaginationChanged = (page) => {
    setCurrentPage(page);
  };

  return (
    <Card
      title={
        <span className="form-title">
          {t("holidayProfileForm.holiday_profile_setup")}
        </span>
      }
      extra={
        <Button
          icon={<PlusCircleOutlined />}
          size="large"
          type="primary"
          style={{ border: "1px solid #fff" }}
          onClick={() => onAdd()}
        >
          {t("general.new")}
        </Button>
      }
    >
      <Spin spinning={isLoading}>
        <Table
          dataSource={holidayProfile}
          columns={columns}
          size="middle"
          pagination={{
            defaultCurrent: currentPage,
            onChange: tablePaginationChanged,
          }}
          rowKey={(record) => record.ProfileKey}
          scroll={{ y: "calc(100vh - 270px)" }}
          onRow={(r) => ({ onClick: () => onRowSelected(r) })}
        />
      </Spin>
      <EntryFormFooter
        footerData={rowSelected}
        showFooter={rowSelected.UpdatedBy ? true : false}
        isApproved={false}
        isVoid={false}
        isPending={false}
        t={t}
      ></EntryFormFooter>
    </Card>
  );
};

HolidayProfileForm.propTypes = {
  holidayProfile: PropTypes.array.isRequired,
  onDelete: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onRowSelected: PropTypes.func.isRequired,
  rowSelected: PropTypes.object.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
};
